import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import useAsync from 'react-use/esm/useAsync';
import {
  InformationCard,
  InformationCardProps,
  InformationItem,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';
import {
  UserEntityUtil,
  useUserEntity,
} from '@dewise-devex/backstage-plugin-utilities-common-client';
import { useNavigate } from 'react-router-dom';

const opts: InformationCardProps = {
  as: 'list',
  asIcon: false,
  title: '',
};

export const Members = () => {
  const navigate = useNavigate();

  const { entity } = useEntity();
  const memberNames = Array.isArray(entity.spec?.members)
    ? (entity.spec.members as string[]).map(email => email.replace('@', '_'))
    : [];
  const memberCount = memberNames.length;
  const userEntityService = useUserEntity();

  const { value: users = [] } = useAsync(async () => {
    const members = await userEntityService.byEntity(entity, {
      withRole: true,
    });
    return UserEntityUtil.toInformationItem(members);
  }, [entity]);

  return (
    <InformationCard
      {...opts}
      title={`Members (${memberCount})`}
      data={{
        items: users,
        itemAction: [
          {
            icon: '' as any,
            action: (item: InformationItem) => {
              navigate(`/catalog/default/user/${item.metadata?.link}`);
            },
          },
        ],
      }}
    />
  );
};
